"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirseekerRegistry__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "owner_",
                type: "address",
            },
            {
                internalType: "address",
                name: "api3ServerV1_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
        ],
        name: "ActivatedDapiName",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
        ],
        name: "ActivatedDataFeedId",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
        ],
        name: "DeactivatedDapiName",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
        ],
        name: "DeactivatedDataFeedId",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "dataFeedDetails",
                type: "bytes",
            },
        ],
        name: "RegisteredDataFeed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "updateParameters",
                type: "bytes",
            },
        ],
        name: "UpdatedDapiNameUpdateParameters",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "updateParameters",
                type: "bytes",
            },
        ],
        name: "UpdatedDataFeedIdUpdateParameters",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "airnode",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "signedApiUrl",
                type: "string",
            },
        ],
        name: "UpdatedSignedApiUrl",
        type: "event",
    },
    {
        inputs: [],
        name: "MAXIMUM_BEACON_COUNT_IN_SET",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXIMUM_SIGNED_API_URL_LENGTH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXIMUM_UPDATE_PARAMETERS_LENGTH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "activeDapiNameCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "activeDataFeed",
        outputs: [
            {
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "dataFeedDetails",
                type: "bytes",
            },
            {
                internalType: "int224",
                name: "dataFeedValue",
                type: "int224",
            },
            {
                internalType: "uint32",
                name: "dataFeedTimestamp",
                type: "uint32",
            },
            {
                internalType: "int224[]",
                name: "beaconValues",
                type: "int224[]",
            },
            {
                internalType: "uint32[]",
                name: "beaconTimestamps",
                type: "uint32[]",
            },
            {
                internalType: "bytes",
                name: "updateParameters",
                type: "bytes",
            },
            {
                internalType: "string[]",
                name: "signedApiUrls",
                type: "string[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "activeDataFeedCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "activeDataFeedIdCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "airnodeToSignedApiUrl",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "api3ServerV1",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "containsBytecode",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
        ],
        name: "dapiNameToUpdateParameters",
        outputs: [
            {
                internalType: "bytes",
                name: "updateParameters",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "dataFeedIdToDetails",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
        ],
        name: "dataFeedIdToUpdateParameters",
        outputs: [
            {
                internalType: "bytes",
                name: "updateParameters",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
        ],
        name: "dataFeedIsRegistered",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockBasefee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "dataFeedDetails",
                type: "bytes",
            },
        ],
        name: "registerDataFeed",
        outputs: [
            {
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
        ],
        name: "setDapiNameToBeActivated",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
        ],
        name: "setDapiNameToBeDeactivated",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "updateParameters",
                type: "bytes",
            },
        ],
        name: "setDapiNameUpdateParameters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
        ],
        name: "setDataFeedIdToBeActivated",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
        ],
        name: "setDataFeedIdToBeDeactivated",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "updateParameters",
                type: "bytes",
            },
        ],
        name: "setDataFeedIdUpdateParameters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "airnode",
                type: "address",
            },
            {
                internalType: "string",
                name: "signedApiUrl",
                type: "string",
            },
        ],
        name: "setSignedApiUrl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "tryMulticall",
        outputs: [
            {
                internalType: "bool[]",
                name: "successes",
                type: "bool[]",
            },
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x60a060405234801561001057600080fd5b50604051612bc7380380612bc783398101604081905261002f9161013d565b816001600160a01b03811661005f57604051631e4fbdf760e01b8152600060048201526024015b60405180910390fd5b610068816100d1565b506001600160a01b0381166100bf5760405162461bcd60e51b815260206004820152601960248201527f4170693353657276657256312061646472657373207a65726f000000000000006044820152606401610056565b6001600160a01b031660805250610170565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b80516001600160a01b038116811461013857600080fd5b919050565b6000806040838503121561015057600080fd5b61015983610121565b915061016760208401610121565b90509250929050565b608051612a206101a76000396000818161025e0152818161131d015281816114ad015281816115c101526118ac0152612a206000f3fe608060405234801561001057600080fd5b50600436106101f05760003560e01c8063796b89b91161010f578063be3cc74d116100a2578063ddb2575211610071578063ddb2575214610420578063f2fde38b14610433578063f8b2cb4f14610446578063fba8f22f1461046157600080fd5b8063be3cc74d146103ca578063d23bab14146103dd578063d3cc6647146103f0578063d4a66d921461041857600080fd5b80638f634751116100de5780638f6347511461037c57806391af241114610384578063ac9650d814610397578063b07a0c2f146103b757600080fd5b8063796b89b91461033f5780637a821819146103455780637ca50e85146103585780638da5cb5b1461036b57600080fd5b806342cbb15c116101875780635d868194116101565780635d868194146103095780636e85b69a1461031c578063715018a61461032f578063773f2edc1461033757600080fd5b806342cbb15c146102af578063437b9116146102b55780634dcc19fe146102d65780635989eaeb146102dc57600080fd5b80632d6a744e116101c35780632d6a744e146102595780633408e4701461029857806336b7840d1461029e5780633aad52b9146102a757600080fd5b8063074244ce146101f5578063085df6ab146102115780631761c219146102315780632412a9cb14610246575b600080fd5b6101fe61010081565b6040519081526020015b60405180910390f35b61022461021f366004611f0d565b610474565b6040516102089190611f77565b61024461023f366004611fd3565b61050e565b005b61024461025436600461201f565b610679565b6102807f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b039091168152602001610208565b466101fe565b6101fe61040081565b6101fe601581565b436101fe565b6102c86102c3366004612038565b610700565b60405161020892919061210b565b486101fe565b6102f96102ea366004611f0d565b6001600160a01b03163b151590565b6040519015158152602001610208565b6101fe610317366004612165565b610866565b61022461032a36600461201f565b610ce2565b610244610cfb565b6101fe610d43565b426101fe565b6102f961035336600461201f565b610d54565b61022461036636600461201f565b610d76565b6000546001600160a01b0316610280565b6101fe610e25565b61024461039236600461201f565b610e41565b6103aa6103a5366004612038565b610ec9565b60405161020891906121a7565b6102446103c536600461201f565b61104a565b6102446103d836600461201f565b6110d3565b6102446103eb366004611fd3565b611159565b6104036103fe36600461201f565b6112aa565b604051610208999897969594939291906121fc565b6101fe611ab3565b61022461042e36600461201f565b611abf565b610244610441366004611f0d565b611ae9565b6101fe610454366004611f0d565b6001600160a01b03163190565b61024461046f3660046122ba565b611b31565b6001602052600090815260409020805461048d906122f6565b80601f01602080910402602001604051908101604052809291908181526020018280546104b9906122f6565b80156105065780601f106104db57610100808354040283529160200191610506565b820191906000526020600020905b8154815290600101906020018083116104e957829003601f168201915b505050505081565b610516611cda565b828061055d5760405162461bcd60e51b8152602060048201526011602482015270446174612066656564204944207a65726f60781b60448201526064015b60405180910390fd5b82826104008111156105b15760405162461bcd60e51b815260206004820152601a60248201527f55706461746520706172616d657465727320746f6f206c6f6e670000000000006044820152606401610554565b600085856040516105c3929190612330565b6040518091039020905080600760008981526020019081526020016000205414610670576000878152600760209081526040808320849055838352600990915290208054869190610613906122f6565b9050146106355760008181526009602052604090206106338688836123a4565b505b867f0aea1ab3b222f6786a08c16b8f93ba421dfe07d2511afa7250ec3e9163b0b420878760405161066792919061248d565b60405180910390a25b50505050505050565b610681611cda565b80806106c05760405162461bcd60e51b815260206004820152600e60248201526d64415049206e616d65207a65726f60901b6044820152606401610554565b6106cb600583611d22565b156106fc5760405182907ff9f5c4d39275e5bd5f3c5c8c55bc35400693aeb978d180b545f88580dc4e1e7790600090a25b5050565b606080828067ffffffffffffffff81111561071d5761071d612340565b604051908082528060200260200182016040528015610746578160200160208202803683370190505b5092508067ffffffffffffffff81111561076257610762612340565b60405190808252806020026020018201604052801561079557816020015b60608152602001906001900390816107805790505b50915060005b8181101561085d57308686838181106107b6576107b66124a9565b90506020028101906107c891906124bf565b6040516107d6929190612330565b600060405180830381855af49150503d8060008114610811576040519150601f19603f3d011682016040523d82523d6000602084013e610816565b606091505b50858381518110610829576108296124a9565b60200260200101858481518110610842576108426124a9565b6020908102919091010191909152901515905260010161079b565b50509250929050565b600081603f1981016109255760008061088185870187612506565b90925090506001600160a01b0382166108dc5760405162461bcd60e51b815260206004820152601460248201527f4169726e6f64652061646472657373207a65726f0000000000000000000000006044820152606401610554565b60408051606084901b6bffffffffffffffffffffffff19166020808301919091526034808301859052835180840390910181526054909201909252805191012093505050610c63565b6101008110610c1b5761093a60156020612548565b61094590602061255f565b61095160156020612548565b61095c90602061255f565b61096790604061255f565b610971919061255f565b8111156109c05760405162461bcd60e51b815260206004820152601a60248201527f4461746120666565642064657461696c7320746f6f206c6f6e670000000000006044820152606401610554565b6000806109cf85870187612634565b915091508282826040516020016109e7929190612731565b6040516020818303038152906040525114610a445760405162461bcd60e51b815260206004820152601760248201527f4461746120666565642064657461696c7320747261696c0000000000000000006044820152606401610554565b815181518114610a965760405162461bcd60e51b815260206004820152601960248201527f506172616d65746572206c656e677468206d69736d61746368000000000000006044820152606401610554565b60008167ffffffffffffffff811115610ab157610ab1612340565b604051908082528060200260200182016040528015610ada578160200160208202803683370190505b50905060005b82811015610c065760006001600160a01b0316858281518110610b0557610b056124a9565b60200260200101516001600160a01b031603610b635760405162461bcd60e51b815260206004820152601460248201527f4169726e6f64652061646472657373207a65726f0000000000000000000000006044820152606401610554565b610be1858281518110610b7857610b786124a9565b6020026020010151858381518110610b9257610b926124a9565b60200260200101516040516bffffffffffffffffffffffff19606084901b1660208201526034810182905260009060540160405160208183030381529060405280519060200120905092915050565b828281518110610bf357610bf36124a9565b6020908102919091010152600101610ae0565b50610c1081611d37565b955050505050610c63565b60405162461bcd60e51b815260206004820152601b60248201527f4461746120666565642064657461696c7320746f6f2073686f727400000000006044820152606401610554565b60008281526002602052604090208054829190610c7f906122f6565b905014610cdb576000828152600260205260409020610c9f8486836123a4565b50817f4fe18adb29a4bae727e770ff666414a639679c10704d95f308a220b9a1b7477c8585604051610cd292919061248d565b60405180910390a25b5092915050565b6002602052600090815260409020805461048d906122f6565b60405162461bcd60e51b815260206004820152601d60248201527f4f776e6572736869702063616e6e6f742062652072656e6f756e6365640000006044820152606401610554565b6000610d4f6003611d67565b905090565b60008181526002602052604081208054610d6d906122f6565b15159392505050565b600081815260076020908152604080832054835260099091529020805460609190610da0906122f6565b80601f0160208091040260200160405190810160405280929190818152602001828054610dcc906122f6565b8015610e195780601f10610dee57610100808354040283529160200191610e19565b820191906000526020600020905b815481529060010190602001808311610dfc57829003601f168201915b50505050509050919050565b6000610e2f611ab3565b610e37610d43565b610d4f919061255f565b610e49611cda565b8080610e8b5760405162461bcd60e51b8152602060048201526011602482015270446174612066656564204944207a65726f60781b6044820152606401610554565b610e96600383611d22565b156106fc5760405182907e58637e39931c35fef05bbfd96b3881a0301ada925534f93fbfd5544df032cd90600090a25050565b6060818067ffffffffffffffff811115610ee557610ee5612340565b604051908082528060200260200182016040528015610f1857816020015b6060815260200190600190039081610f035790505b50915060005b8181101561104257600030868684818110610f3b57610f3b6124a9565b9050602002810190610f4d91906124bf565b604051610f5b929190612330565b600060405180830381855af49150503d8060008114610f96576040519150601f19603f3d011682016040523d82523d6000602084013e610f9b565b606091505b50858481518110610fae57610fae6124a9565b6020908102919091010152905080611039576000848381518110610fd457610fd46124a9565b60200260200101519050600081511115610ff15780518082602001fd5b60405162461bcd60e51b815260206004820152601b60248201527f4d756c746963616c6c3a204e6f2072657665727420737472696e6700000000006044820152606401610554565b50600101610f1e565b505092915050565b611052611cda565b80806110945760405162461bcd60e51b8152602060048201526011602482015270446174612066656564204944207a65726f60781b6044820152606401610554565b61109f600383611d71565b156106fc5760405182907f0b7c1d36481aee25427040847eb1bb0fe4419a9daf1a3daa7a2ed118a20128bf90600090a25050565b6110db611cda565b808061111a5760405162461bcd60e51b815260206004820152600e60248201526d64415049206e616d65207a65726f60901b6044820152606401610554565b611125600583611d71565b156106fc5760405182907f240586c4e7a24b6151c6cbee3daebf773eae2e14f003cf24b204cc164c3066a790600090a25050565b611161611cda565b82806111a05760405162461bcd60e51b815260206004820152600e60248201526d64415049206e616d65207a65726f60901b6044820152606401610554565b82826104008111156111f45760405162461bcd60e51b815260206004820152601a60248201527f55706461746520706172616d657465727320746f6f206c6f6e670000000000006044820152606401610554565b60008585604051611206929190612330565b6040518091039020905080600860008981526020019081526020016000205414610670576000878152600860209081526040808320849055838352600990915290208054869190611256906122f6565b9050146112785760008181526009602052604090206112768688836123a4565b505b867f3ebb9b0f7d1ab582553a43d38e03a3533602282ff4fc10f5073d0b67d990dbfd878760405161066792919061248d565b600080606060008060608060608060006112c2610d43565b9050808b10156112e9576112d760038c611d7d565b99506112e28a610d76565b92506113e0565b6112f36005611d67565b6112fd908261255f565b8b10156113e057611319611311828d612788565b600590611d7d565b98507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663472c22f18a60405160200161135d91815260200190565b604051602081830303815290604052805190602001206040518263ffffffff1660e01b815260040161139191815260200190565b602060405180830381865afa1580156113ae573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906113d2919061279b565b99506113dd89611abf565b92505b89156115285760008a815260026020526040902080546113ff906122f6565b80601f016020809104026020016040519081016040528092919081815260200182805461142b906122f6565b80156114785780601f1061144d57610100808354040283529160200191611478565b820191906000526020600020905b81548152906001019060200180831161145b57829003601f168201915b50506040517f67a7cfb7000000000000000000000000000000000000000000000000000000008152600481018f9052939b50507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316926367a7cfb7925060240190506040805180830381865afa1580156114fe573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061152291906127b4565b90975095505b875115611aa55760408851036117a8576040805160018082528183019092529060208083019080368337505060408051600180825281830190925292975090506020808301908036833701905050604080516001808252818301909252919550816020015b606081526020019060019003908161158d579050509150600080898060200190518101906115bb91906127fd565b915091507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166367a7cfb761163a84846040516bffffffffffffffffffffffff19606084901b1660208201526034810182905260009060540160405160208183030381529060405280519060200120905092915050565b6040518263ffffffff1660e01b815260040161165891815260200190565b6040805180830381865afa158015611674573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061169891906127b4565b886000815181106116ab576116ab6124a9565b60200260200101886000815181106116c5576116c56124a9565b63ffffffff909316602093840291909101830152601b9290920b9091526001600160a01b03831660009081526001909152604090208054611705906122f6565b80601f0160208091040260200160405190810160405280929190818152602001828054611731906122f6565b801561177e5780601f106117535761010080835404028352916020019161177e565b820191906000526020600020905b81548152906001019060200180831161176157829003601f168201915b505050505084600081518110611796576117966124a9565b60200260200101819052505050611aa5565b600080898060200190518101906117bf9190612889565b815191935091508067ffffffffffffffff8111156117df576117df612340565b604051908082528060200260200182016040528015611808578160200160208202803683370190505b5097508067ffffffffffffffff81111561182457611824612340565b60405190808252806020026020018201604052801561184d578160200160208202803683370190505b5096508067ffffffffffffffff81111561186957611869612340565b60405190808252806020026020018201604052801561189c57816020015b60608152602001906001900390816118875790505b50945060005b81811015611aa0577f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166367a7cfb76119088684815181106118ee576118ee6124a9565b6020026020010151868581518110610b9257610b926124a9565b6040518263ffffffff1660e01b815260040161192691815260200190565b6040805180830381865afa158015611942573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061196691906127b4565b8a8381518110611978576119786124a9565b602002602001018a8481518110611991576119916124a9565b602002602001018263ffffffff1663ffffffff1681525082601b0b601b0b8152505050600160008583815181106119ca576119ca6124a9565b60200260200101516001600160a01b03166001600160a01b0316815260200190815260200160002080546119fd906122f6565b80601f0160208091040260200160405190810160405280929190818152602001828054611a29906122f6565b8015611a765780601f10611a4b57610100808354040283529160200191611a76565b820191906000526020600020905b815481529060010190602001808311611a5957829003601f168201915b5050505050868281518110611a8d57611a8d6124a9565b60209081029190910101526001016118a2565b505050505b509193959799909294969850565b6000610d4f6005611d67565b600081815260086020908152604080832054835260099091529020805460609190610da0906122f6565b60405162461bcd60e51b815260206004820152601f60248201527f4f776e6572736869702063616e6e6f74206265207472616e73666572726564006044820152606401610554565b611b39611cda565b6001600160a01b038316611b8f5760405162461bcd60e51b815260206004820152601460248201527f4169726e6f64652061646472657373207a65726f0000000000000000000000006044820152606401610554565b6101008282604051602001611ba5929190612330565b604051602081830303815290604052511115611c035760405162461bcd60e51b815260206004820152601760248201527f5369676e6564204150492055524c20746f6f206c6f6e670000000000000000006044820152606401610554565b8181604051602001611c16929190612330565b60408051601f1981840301815282825280516020918201206001600160a01b038716600090815260018352929092209192611c5292910161294c565b6040516020818303038152906040528051906020012014611cd5576001600160a01b0383166000908152600160205260409020611c908284836123a4565b50826001600160a01b03167f1de1502db80e21e5a66f15b7adabc8c7c32f1fa1a0b7c51dbe01f4e50fe65c498383604051611ccc92919061248d565b60405180910390a25b505050565b6000546001600160a01b03163314611d20576040517f118cdaa7000000000000000000000000000000000000000000000000000000008152336004820152602401610554565b565b6000611d2e8383611d89565b90505b92915050565b600081604051602001611d4a91906129c1565b604051602081830303815290604052805190602001209050919050565b6000611d31825490565b6000611d2e8383611e7c565b6000611d2e8383611ecb565b60008181526001830160205260408120548015611e72576000611dad600183612788565b8554909150600090611dc190600190612788565b9050808214611e26576000866000018281548110611de157611de16124a9565b9060005260206000200154905080876000018481548110611e0457611e046124a9565b6000918252602080832090910192909255918252600188019052604090208390555b8554869080611e3757611e376129d4565b600190038181906000526020600020016000905590558560010160008681526020019081526020016000206000905560019350505050611d31565b6000915050611d31565b6000818152600183016020526040812054611ec357508154600181810184556000848152602080822090930184905584548482528286019093526040902091909155611d31565b506000611d31565b6000826000018281548110611ee257611ee26124a9565b9060005260206000200154905092915050565b6001600160a01b0381168114611f0a57600080fd5b50565b600060208284031215611f1f57600080fd5b8135611f2a81611ef5565b9392505050565b6000815180845260005b81811015611f5757602081850181015186830182015201611f3b565b506000602082860101526020601f19601f83011685010191505092915050565b602081526000611d2e6020830184611f31565b60008083601f840112611f9c57600080fd5b50813567ffffffffffffffff811115611fb457600080fd5b602083019150836020828501011115611fcc57600080fd5b9250929050565b600080600060408486031215611fe857600080fd5b83359250602084013567ffffffffffffffff81111561200657600080fd5b61201286828701611f8a565b9497909650939450505050565b60006020828403121561203157600080fd5b5035919050565b6000806020838503121561204b57600080fd5b823567ffffffffffffffff81111561206257600080fd5b8301601f8101851361207357600080fd5b803567ffffffffffffffff81111561208a57600080fd5b8560208260051b840101111561209f57600080fd5b6020919091019590945092505050565b600082825180855260208501945060208160051b8301016020850160005b838110156120ff57601f198584030188526120e9838351611f31565b60209889019890935091909101906001016120cd565b50909695505050505050565b6040808252835190820181905260009060208501906060840190835b818110156121475783511515835260209384019390920191600101612127565b5050838103602085015261215b81866120af565b9695505050505050565b6000806020838503121561217857600080fd5b823567ffffffffffffffff81111561218f57600080fd5b61219b85828601611f8a565b90969095509350505050565b602081526000611d2e60208301846120af565b600081518084526020840193506020830160005b828110156121f257815163ffffffff168652602095860195909101906001016121ce565b5093949350505050565b8981528860208201526101206040820152600061221d61012083018a611f31565b601b89900b606084015263ffffffff8816608084015282810360a08401528651808252602080890192019060005b8181101561226c578351601b0b83526020938401939092019160010161224b565b505083810360c085015261228081886121ba565b91505082810360e08401526122958186611f31565b90508281036101008401526122aa81856120af565b9c9b505050505050505050505050565b6000806000604084860312156122cf57600080fd5b83356122da81611ef5565b9250602084013567ffffffffffffffff81111561200657600080fd5b600181811c9082168061230a57607f821691505b60208210810361232a57634e487b7160e01b600052602260045260246000fd5b50919050565b8183823760009101908152919050565b634e487b7160e01b600052604160045260246000fd5b601f821115611cd557806000526020600020601f840160051c8101602085101561237d5750805b601f840160051c820191505b8181101561239d5760008155600101612389565b5050505050565b67ffffffffffffffff8311156123bc576123bc612340565b6123d0836123ca83546122f6565b83612356565b6000601f84116001811461240457600085156123ec5750838201355b600019600387901b1c1916600186901b17835561239d565b600083815260209020601f19861690835b828110156124355786850135825560209485019460019092019101612415565b50868210156124525760001960f88860031b161c19848701351681555b505060018560011b0183555050505050565b81835281816020850137506000828201602090810191909152601f909101601f19169091010190565b6020815260006124a1602083018486612464565b949350505050565b634e487b7160e01b600052603260045260246000fd5b6000808335601e198436030181126124d657600080fd5b83018035915067ffffffffffffffff8211156124f157600080fd5b602001915036819003821315611fcc57600080fd5b6000806040838503121561251957600080fd5b823561252481611ef5565b946020939093013593505050565b634e487b7160e01b600052601160045260246000fd5b8082028115828204841417611d3157611d31612532565b80820180821115611d3157611d31612532565b604051601f8201601f1916810167ffffffffffffffff8111828210171561259b5761259b612340565b604052919050565b600067ffffffffffffffff8211156125bd576125bd612340565b5060051b60200190565b600082601f8301126125d857600080fd5b81356125eb6125e6826125a3565b612572565b8082825260208201915060208360051b86010192508583111561260d57600080fd5b602085015b8381101561262a578035835260209283019201612612565b5095945050505050565b6000806040838503121561264757600080fd5b823567ffffffffffffffff81111561265e57600080fd5b8301601f8101851361266f57600080fd5b803561267d6125e6826125a3565b8082825260208201915060208360051b85010192508783111561269f57600080fd5b6020840193505b828410156126ca5783356126b981611ef5565b8252602093840193909101906126a6565b9450505050602083013567ffffffffffffffff8111156126e957600080fd5b6126f5858286016125c7565b9150509250929050565b600081518084526020840193506020830160005b828110156121f2578151865260209586019590910190600101612713565b6040808252835190820181905260009060208501906060840190835b818110156127745783516001600160a01b031683526020938401939092019160010161274d565b5050838103602085015261215b81866126ff565b81810381811115611d3157611d31612532565b6000602082840312156127ad57600080fd5b5051919050565b600080604083850312156127c757600080fd5b825180601b0b81146127d857600080fd5b602084015190925063ffffffff811681146127f257600080fd5b809150509250929050565b6000806040838503121561281057600080fd5b825161281b81611ef5565b6020939093015192949293505050565b600082601f83011261283c57600080fd5b815161284a6125e6826125a3565b8082825260208201915060208360051b86010192508583111561286c57600080fd5b602085015b8381101561262a578051835260209283019201612871565b6000806040838503121561289c57600080fd5b825167ffffffffffffffff8111156128b357600080fd5b8301601f810185136128c457600080fd5b80516128d26125e6826125a3565b8082825260208201915060208360051b8501019250878311156128f457600080fd5b6020840193505b8284101561291f57835161290e81611ef5565b8252602093840193909101906128fb565b80955050505050602083015167ffffffffffffffff81111561294057600080fd5b6126f58582860161282b565b600080835461295a816122f6565b6001821680156129715760018114612986576129b6565b60ff19831686528115158202860193506129b6565b86600052602060002060005b838110156129ae57815488820152600190910190602001612992565b505081860193505b509195945050505050565b602081526000611d2e60208301846126ff565b634e487b7160e01b600052603160045260246000fdfea264697066735822122053f2748f5faa2186176f50becc1d9d3be61b0dbf659987c55628173423e5126964736f6c634300081b0033";
const isSuperArgs = (xs) => xs.length > 1;
class AirseekerRegistry__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(owner_, api3ServerV1_, overrides) {
        return super.getDeployTransaction(owner_, api3ServerV1_, overrides || {});
    }
    deploy(owner_, api3ServerV1_, overrides) {
        return super.deploy(owner_, api3ServerV1_, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.AirseekerRegistry__factory = AirseekerRegistry__factory;
//# sourceMappingURL=AirseekerRegistry__factory.js.map